'use client';

import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

import { useGoatImage } from '../../../hooks/images/useGoatImage';
import { useRouter } from '../../../hooks/router/useCustomRouter';
import { Button } from '../../atoms';
import { Image } from '../../atoms/image/Image';

export const UnsupportedCountry = () => {
	const { $t } = useIntl();
	const imageSrc = useGoatImage('unsupportedCountry');
	const { push } = useRouter();

	return (
		<S.Wrapper>
			<S.Img alt="unsupported country" src={imageSrc} width={240} />
			<S.Container>
				<S.Title>{$t('unsupportedCountryPage.title')}</S.Title>
				<S.Info>{$t('unsupportedCountryPage.subtitle')}</S.Info>
			</S.Container>
			<S.BottomWrapper>
				<Button
					fullWidth
					testID="try-again"
					text={$t('unsupportedCountryPage.cta')}
					onClick={() => push('/')}
				/>
			</S.BottomWrapper>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: ${({ theme }) => theme.colors.white};
		min-height: 100%;
		${({ theme }) => theme.breakpoints.queries.only.mobile} {
			margin: 0;
		}
	`;
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
	`;
	export const Img = styled(Image)`
		margin: ${({ theme }) => `${theme.spacings.xxxlarge} 0 0 0`};
		align-self: center;
	`;
	export const Title = styled.label`
		${({ theme }) => theme.fonts.headings.title5};
	`;
	export const Info = styled.label`
		${({ theme }) => theme.fonts.text.text3};
		margin: ${({ theme }) => `${theme.spacings.large} 0 ${theme.spacings.large} 0`};
		text-align: center;
	`;
	export const BottomWrapper = styled.div`
		width: 100%;
		margin-top: auto;
		padding: ${({ theme }) => theme.spacings.small};
		border-top: 1px solid ${({ theme }) => theme.colors.borders.main.divider};

		${({ theme }) => theme.breakpoints.queries.above.mobile} {
			width: 400px;
			margin-top: 0;
		}
	`;
}
